import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text}; 
    transition: all 0.25s linear;
  }
  h1 {
    color: ${({ theme }) => theme.heading}; 
  }
`;